import React from "react";
import RightSideModel from "src/components/popup/rightSide/RightSideModel";
import TTSEventForm from "../form/TTSEventForm/TTSEventForm";

const titlePopup = (isEdit) => {
  return isEdit ? "Edit Event" : "Create Event";
};

const TTSEventPopup = ({
  recordForEdit,
  openPopup,
  setOpenPopup,
  addOrEdit,
  errorsForm,
  eventType,
}) => {
  return (
    <RightSideModel
      openPopup={openPopup}
      setOpenPopup={setOpenPopup}
      title={titlePopup(Boolean(recordForEdit))}
    >
      <TTSEventForm
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        errorsForm={errorsForm}
        eventType={eventType}
      />
    </RightSideModel>
  );
};

export default TTSEventPopup;
